var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 22C3.34315 22 2 20.6569 2 19V11.3361C2 10.4857 2.36096 9.67518 2.99311 9.10625L9.9931 2.80625C11.134 1.77943 12.866 1.77943 14.0069 2.80625L21.0069 9.10625C21.639 9.67518 22 10.4857 22 11.3361V19C22 20.6569 20.6569 22 19 22H5ZM21 11.3361V19C21 20.1046 20.1046 21 19 21H16V15C16 13.3432 14.6569 12 13 12H11C9.34315 12 8 13.3432 8 15V21H5C3.89543 21 3 20.1046 3 19V11.3361C3 10.7692 3.24064 10.2288 3.66207 9.84954L10.6621 3.54955C11.4227 2.865 12.5773 2.865 13.3379 3.54954L20.3379 9.84954C20.7594 10.2288 21 10.7692 21 11.3361ZM9 21V15C9 13.8955 9.89543 13 11 13H13C14.1046 13 15 13.8955 15 15V21H9Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3e02c8e014cfe8b6413a50c866da6b64.svg";
export { ForwardRef as ReactComponent };